import request from '@/utils/request'
import NProgress from 'nprogress' // progress bar

export function login(data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/sys/logout',
    method: 'post'
  })
}

export function userGet(params) {
  return request({
    url: '/sys/user/get',
    method: 'get',
    params
  })
}

export function upload(relateId, files) {
  if (!files || files.length == 0) {
    return;
  }
  let formData = new FormData();
  formData.append("relateId", relateId);
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    formData.append('files', file, file.name);
  }
  NProgress.start()
  return request({
    url: '/storage/upload',
    method: 'post',
    data: formData,
    headers: {
      "post": {'Content-Type': 'multipart/form-data'}
    }
  }).finally(() => {
    NProgress.done()
  })
}

export function getOptions(params) {
  return request({
    url: '/sys/get/options',
    method: 'get',
    params
  })
}

export function buildOptions(options, data) {
  for (let i = 0; i < data.length; i++) {
    const d = data[i];
    const children = [];
    if (d.children && d.children.length > 0) {
      buildOptions(children, d.children);
    }
    const result = {
      id: d.key,
      title: d.value,
      level: d.level,
      value: d.key,
      label: d.value
    };
    if (children.length > 0) {
      result.children = children;
    }
    options.push(result);
  }
  return options;
}



// WEBPACK FOOTER //
// ./src/user/api/sys.js